import { getToken } from '../../Utils/authUtils';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { REPORTS } from '../../constant';

/** Mark every notification for the logged-in user as read. */
export const markAllNotificationsRead = createAsyncThunk(
  'reports/markAllNotificationsRead',
  async (_: void, { rejectWithValue }) => {
    try {
      const res = await fetch(REPORTS.MARK_ALL_NOTIFICATIONS_READ, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + getToken(),
        },
        // Fastify rejects an empty payload when the request declares a JSON content type
        // (FST_ERR_CTP_EMPTY_JSON_BODY, 400). The handler reads nothing but the token, so
        // an empty object is all that is needed to satisfy the parser.
        body: JSON.stringify({}),
      });
      if (!res.ok) {
        const errorData = await res.json().catch(() => ({}));
        return rejectWithValue(errorData.msg || 'Failed to mark all notifications as read');
      }
      return {};
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
